// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
	BeginAbimImportData,
	BeginAbimImportResponses,
	BulkUpdateLearningPlanTopicsData,
	BulkUpdateLearningPlanTopicsResponses,
	ClearFlashcardStatusesData,
	ClearFlashcardStatusesResponses,
	ClearResponsesData,
	ClearResponsesResponses,
	CreateInAppPurchaseData,
	CreateInAppPurchaseResponses,
	CreateNoteData,
	CreateNoteResponses,
	CreateOrUpdateDismissibleAlertData,
	CreateOrUpdateDismissibleAlertResponses,
	CreateOrUpdateLearningPlanTaskStatusData,
	CreateOrUpdateLearningPlanTaskStatusResponses,
	CreateQuizAttemptData,
	CreateQuizAttemptErrors,
	CreateQuizAttemptResponses,
	CreateUnlockTokenData,
	CreateUnlockTokenErrors,
	CreateUnlockTokenResponses,
	DeleteNoteData,
	DeleteNoteResponses,
	FetchQuizAttemptsData,
	FetchQuizAttemptsResponses,
	FetchQuizFormsData,
	FetchQuizFormsResponses,
	FetchUnlockTokensData,
	FetchUnlockTokensResponses,
	FindImIteResultsData,
	FindImIteResultsResponses,
	GetAbimImportTokenByIdData,
	GetAbimImportTokenByIdErrors,
	GetAbimImportTokenByIdResponses,
	GetAbimInfoData,
	GetAbimInfoResponses,
	GetAllAbimTestResultsData,
	GetAllAbimTestResultsResponses,
	GetAllChapterReadStatusesData,
	GetAllChapterReadStatusesResponses,
	GetAllDismissibleAlertsData,
	GetAllDismissibleAlertsResponses,
	GetAllFlashcardStatusesData,
	GetAllFlashcardStatusesResponses,
	GetAllImIteResultsData,
	GetAllImIteResultsResponses,
	GetAllInAppPurchasesData,
	GetAllInAppPurchasesResponses,
	GetAllLearningPlanTaskStatusesData,
	GetAllLearningPlanTaskStatusesResponses,
	GetAllLearningPlanTopicsData,
	GetAllLearningPlanTopicsResponses,
	GetAllMasteredSectionsData,
	GetAllMasteredSectionsResponses,
	GetAllMessagesData,
	GetAllMessagesResponses,
	GetAllNotesData,
	GetAllNotesResponses,
	GetAllQuestionStarsData,
	GetAllQuestionStarsResponses,
	GetAllRecentActivitiesData,
	GetAllRecentActivitiesResponses,
	GetApiResponsesJsonData,
	GetApiResponsesJsonResponses,
	GetAppMessagesData,
	GetAppMessagesResponses,
	GetLatestAbimImportTokenData,
	GetLatestAbimImportTokenErrors,
	GetLatestAbimImportTokenResponses,
	GetLivePeerComparisonData,
	GetLivePeerComparisonResponses,
	GetLoggedInUserData,
	GetLoggedInUserDetailsData,
	GetLoggedInUserDetailsResponses,
	GetLoggedInUserResponses,
	GetLoggedInUserWithoutAuthorizationData,
	GetLoggedInUserWithoutAuthorizationResponses,
	GetSubmissionAnnualSummaryData,
	GetSubmissionAnnualSummaryResponses,
	GetSubmissionsSummaryData,
	GetSubmissionsSummaryResponses,
	LinkImIteResultsData,
	LinkImIteResultsResponses,
	MarkFlashcardData,
	MarkFlashcardResponses,
	SaveAnswerData,
	SaveAnswerResponses,
	SaveRecentActivitiesData,
	SaveRecentActivitiesResponses,
	SubmitCreditsData,
	SubmitCreditsResponses,
	UpdateAbimInfoData,
	UpdateAbimInfoResponses,
	UpdateChapterReadStatusData,
	UpdateChapterReadStatusResponses,
	UpdateLearningPlanTopicData,
	UpdateLearningPlanTopicResponses,
	UpdateMasteredSectionData,
	UpdateMasteredSectionResponses,
	UpdateQuestionStarData,
	UpdateQuestionStarResponses,
} from "./types.gen";

export type Options<
	TData extends TDataShape = TDataShape,
	ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
	/**
	 * You can provide a client instance returned by `createClient()` instead of
	 * individual options. This might be also useful if you want to implement a
	 * custom client.
	 */
	client?: Client;
	/**
	 * You can pass arbitrary values through the `meta` object. This can be
	 * used to access values that aren't defined as part of the SDK function.
	 */
	meta?: Record<string, unknown>;
};

export class AbimImportService {
	/**
	 * Begin ABIM import
	 */
	public static beginAbimImport<ThrowOnError extends boolean = true>(
		options?: Options<BeginAbimImportData, ThrowOnError>,
	) {
		return (options?.client ?? client).post<
			BeginAbimImportResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/abim_import/import_tokens/begin_import.json", ...options });
	}

	/**
	 * Get latest ABIM import token
	 */
	public static getLatestAbimImportToken<ThrowOnError extends boolean = true>(
		options?: Options<GetLatestAbimImportTokenData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetLatestAbimImportTokenResponses,
			GetLatestAbimImportTokenErrors,
			ThrowOnError
		>({ url: "/api/abim_import/import_tokens/latest.json", ...options });
	}

	/**
	 * Get ABIM import token by ID
	 */
	public static getAbimImportTokenById<ThrowOnError extends boolean = true>(
		options: Options<GetAbimImportTokenByIdData, ThrowOnError>,
	) {
		return (options.client ?? client).get<
			GetAbimImportTokenByIdResponses,
			GetAbimImportTokenByIdErrors,
			ThrowOnError
		>({ url: "/api/abim_import/import_tokens/{id}.json", ...options });
	}

	/**
	 * Get all ABIM test results
	 */
	public static getAllAbimTestResults<ThrowOnError extends boolean = true>(
		options?: Options<GetAllAbimTestResultsData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetAllAbimTestResultsResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/abim_import/test_results.json", ...options });
	}
}

export class ChapterReadStatusesService {
	/**
	 * Get all chapter read statuses
	 */
	public static getAllChapterReadStatuses<ThrowOnError extends boolean = true>(
		options?: Options<GetAllChapterReadStatusesData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetAllChapterReadStatusesResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/chapter_read_statuses.json", ...options });
	}

	/**
	 * Update chapter read status
	 */
	public static updateChapterReadStatus<ThrowOnError extends boolean = true>(
		options: Options<UpdateChapterReadStatusData, ThrowOnError>,
	) {
		return (options.client ?? client).patch<
			UpdateChapterReadStatusResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/chapter_read_statuses/{chapterId}.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options.headers,
			},
		});
	}
}

export class CoreService {
	/**
	 * Get current quiz attempts
	 */
	public static fetchQuizAttempts<ThrowOnError extends boolean = true>(
		options?: Options<FetchQuizAttemptsData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			FetchQuizAttemptsResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/core/quiz_attempts.json", ...options });
	}

	/**
	 * Create quiz attempt
	 */
	public static createQuizAttempt<ThrowOnError extends boolean = true>(
		options?: Options<CreateQuizAttemptData, ThrowOnError>,
	) {
		return (options?.client ?? client).post<
			CreateQuizAttemptResponses,
			CreateQuizAttemptErrors,
			ThrowOnError
		>({
			url: "/api/core/quiz_attempts.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	/**
	 * Get all CORE quiz forms
	 */
	public static fetchQuizForms<ThrowOnError extends boolean = true>(
		options?: Options<FetchQuizFormsData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			FetchQuizFormsResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/core/quiz_forms.json", ...options });
	}

	/**
	 * Get current CORE unlock tokens
	 */
	public static fetchUnlockTokens<ThrowOnError extends boolean = true>(
		options?: Options<FetchUnlockTokensData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			FetchUnlockTokensResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/core/unlock_tokens.json", ...options });
	}

	/**
	 * Create unlock token
	 */
	public static createUnlockToken<ThrowOnError extends boolean = true>(
		options?: Options<CreateUnlockTokenData, ThrowOnError>,
	) {
		return (options?.client ?? client).post<
			CreateUnlockTokenResponses,
			CreateUnlockTokenErrors,
			ThrowOnError
		>({
			url: "/api/core/unlock_tokens.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}

export class DismissibleAlertsService {
	/**
	 * Get all dismissible alerts
	 */
	public static getAllDismissibleAlerts<ThrowOnError extends boolean = true>(
		options?: Options<GetAllDismissibleAlertsData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetAllDismissibleAlertsResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/dismissible_alerts.json", ...options });
	}

	/**
	 * Create or update dismissible alert
	 */
	public static createOrUpdateDismissibleAlert<
		ThrowOnError extends boolean = true,
	>(options?: Options<CreateOrUpdateDismissibleAlertData, ThrowOnError>) {
		return (options?.client ?? client).post<
			CreateOrUpdateDismissibleAlertResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/dismissible_alerts.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}

export class FlashcardStatusesService {
	/**
	 * Get all flashcard statuses
	 */
	public static getAllFlashcardStatuses<ThrowOnError extends boolean = true>(
		options?: Options<GetAllFlashcardStatusesData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetAllFlashcardStatusesResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/flashcard_statuses.json", ...options });
	}

	/**
	 * Create or update flashcard status
	 */
	public static markFlashcard<ThrowOnError extends boolean = true>(
		options?: Options<MarkFlashcardData, ThrowOnError>,
	) {
		return (options?.client ?? client).post<
			MarkFlashcardResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/flashcard_statuses.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	/**
	 * Clear user flashcard statuses
	 */
	public static clearFlashcardStatuses<ThrowOnError extends boolean = true>(
		options?: Options<ClearFlashcardStatusesData, ThrowOnError>,
	) {
		return (options?.client ?? client).delete<
			ClearFlashcardStatusesResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/flashcard_statuses/destroy_all.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}

export class ImIteResultsService {
	/**
	 * Get all IM-ITE results
	 */
	public static getAllImIteResults<ThrowOnError extends boolean = true>(
		options?: Options<GetAllImIteResultsData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetAllImIteResultsResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/im_ite_results.json", ...options });
	}

	/**
	 * Find IM-ITE results
	 */
	public static findImIteResults<ThrowOnError extends boolean = true>(
		options?: Options<FindImIteResultsData, ThrowOnError>,
	) {
		return (options?.client ?? client).post<
			FindImIteResultsResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/im_ite_results/find_results.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	/**
	 * Link IM-ITE result
	 */
	public static linkImIteResults<ThrowOnError extends boolean = true>(
		options?: Options<LinkImIteResultsData, ThrowOnError>,
	) {
		return (options?.client ?? client).post<
			LinkImIteResultsResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/im_ite_results/link_result.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}

export class InAppPurchasesService {
	/**
	 * Get all in-app purchases
	 */
	public static getAllInAppPurchases<ThrowOnError extends boolean = true>(
		options?: Options<GetAllInAppPurchasesData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetAllInAppPurchasesResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/in_app_purchases.json", ...options });
	}

	/**
	 * Create or verify in-app purchase
	 */
	public static createInAppPurchase<ThrowOnError extends boolean = true>(
		options?: Options<CreateInAppPurchaseData, ThrowOnError>,
	) {
		return (options?.client ?? client).post<
			CreateInAppPurchaseResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/in_app_purchases.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}

export class LearningPlanService {
	/**
	 * Get all learning plan task statuses
	 */
	public static getAllLearningPlanTaskStatuses<
		ThrowOnError extends boolean = true,
	>(options?: Options<GetAllLearningPlanTaskStatusesData, ThrowOnError>) {
		return (options?.client ?? client).get<
			GetAllLearningPlanTaskStatusesResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/learning_plan_task_statuses.json", ...options });
	}

	/**
	 * Create or update learning plan task status
	 */
	public static createOrUpdateLearningPlanTaskStatus<
		ThrowOnError extends boolean = true,
	>(options?: Options<CreateOrUpdateLearningPlanTaskStatusData, ThrowOnError>) {
		return (options?.client ?? client).post<
			CreateOrUpdateLearningPlanTaskStatusResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/learning_plan_task_statuses.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	/**
	 * Get all learning plan topics
	 */
	public static getAllLearningPlanTopics<ThrowOnError extends boolean = true>(
		options?: Options<GetAllLearningPlanTopicsData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetAllLearningPlanTopicsResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/learning_plan_topics.json", ...options });
	}

	/**
	 * Bulk update learning plan topics
	 */
	public static bulkUpdateLearningPlanTopics<
		ThrowOnError extends boolean = true,
	>(options?: Options<BulkUpdateLearningPlanTopicsData, ThrowOnError>) {
		return (options?.client ?? client).post<
			BulkUpdateLearningPlanTopicsResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/learning_plan_topics/bulk_update.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	/**
	 * Update learning plan topic
	 */
	public static updateLearningPlanTopic<ThrowOnError extends boolean = true>(
		options: Options<UpdateLearningPlanTopicData, ThrowOnError>,
	) {
		return (options.client ?? client).patch<
			UpdateLearningPlanTopicResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/learning_plan_topics/{id}.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options.headers,
			},
		});
	}

	/**
	 * Get all mastered sections
	 */
	public static getAllMasteredSections<ThrowOnError extends boolean = true>(
		options?: Options<GetAllMasteredSectionsData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetAllMasteredSectionsResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/mastered_sections.json", ...options });
	}

	/**
	 * Update mastered section
	 */
	public static updateMasteredSection<ThrowOnError extends boolean = true>(
		options: Options<UpdateMasteredSectionData, ThrowOnError>,
	) {
		return (options.client ?? client).patch<
			UpdateMasteredSectionResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/mastered_sections/{id}.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options.headers,
			},
		});
	}
}

export class LoggedInUserService {
	/**
	 * Get logged in user
	 */
	public static getLoggedInUser<ThrowOnError extends boolean = true>(
		options?: Options<GetLoggedInUserData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetLoggedInUserResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/user.json", ...options });
	}

	/**
	 * Get logged in user without authorization
	 */
	public static getLoggedInUserWithoutAuthorization<
		ThrowOnError extends boolean = true,
	>(options?: Options<GetLoggedInUserWithoutAuthorizationData, ThrowOnError>) {
		return (options?.client ?? client).get<
			GetLoggedInUserWithoutAuthorizationResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/user/without_authorization.json", ...options });
	}

	/**
	 * Get logged in user details
	 */
	public static getLoggedInUserDetails<ThrowOnError extends boolean = true>(
		options?: Options<GetLoggedInUserDetailsData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetLoggedInUserDetailsResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/user/details.json", ...options });
	}
}

export class MessagesService {
	/**
	 * Get all messages
	 */
	public static getAllMessages<ThrowOnError extends boolean = true>(
		options?: Options<GetAllMessagesData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetAllMessagesResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/messages.json", ...options });
	}

	/**
	 * Get app messages
	 */
	public static getAppMessages<ThrowOnError extends boolean = true>(
		options?: Options<GetAppMessagesData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetAppMessagesResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/messages/app_messages.json", ...options });
	}
}

export class NotesService {
	/**
	 * Get all notes
	 */
	public static getAllNotes<ThrowOnError extends boolean = true>(
		options?: Options<GetAllNotesData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetAllNotesResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/notes.json", ...options });
	}

	/**
	 * Create note
	 */
	public static createNote<ThrowOnError extends boolean = true>(
		options?: Options<CreateNoteData, ThrowOnError>,
	) {
		return (options?.client ?? client).post<
			CreateNoteResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/notes.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	/**
	 * Delete note
	 */
	public static deleteNote<ThrowOnError extends boolean = true>(
		options: Options<DeleteNoteData, ThrowOnError>,
	) {
		return (options.client ?? client).delete<
			DeleteNoteResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/notes/{id}.json", ...options });
	}
}

export class QuestionStarsService {
	/**
	 * Get all question stars
	 */
	public static getAllQuestionStars<ThrowOnError extends boolean = true>(
		options?: Options<GetAllQuestionStarsData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetAllQuestionStarsResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/question_stars.json", ...options });
	}

	/**
	 * Update question star
	 */
	public static updateQuestionStar<ThrowOnError extends boolean = true>(
		options: Options<UpdateQuestionStarData, ThrowOnError>,
	) {
		return (options.client ?? client).patch<
			UpdateQuestionStarResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/question_stars/{id}.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options.headers,
			},
		});
	}
}

export class RecentActivitiesService {
	/**
	 * Get all recent activities
	 */
	public static getAllRecentActivities<ThrowOnError extends boolean = true>(
		options?: Options<GetAllRecentActivitiesData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetAllRecentActivitiesResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/recent_activities.json", ...options });
	}

	/**
	 * Create or update recent activities
	 */
	public static saveRecentActivities<ThrowOnError extends boolean = true>(
		options?: Options<SaveRecentActivitiesData, ThrowOnError>,
	) {
		return (options?.client ?? client).post<
			SaveRecentActivitiesResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/recent_activities.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}

export class ResponsesService {
	/**
	 * destroy_all response
	 *
	 * Deletes specified responses for the current user.
	 */
	public static clearResponses<ThrowOnError extends boolean = true>(
		options?: Options<ClearResponsesData, ThrowOnError>,
	) {
		return (options?.client ?? client).delete<
			ClearResponsesResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/responses/destroy_all.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	/**
	 * live_peer_comparison response
	 */
	public static getLivePeerComparison<ThrowOnError extends boolean = true>(
		options?: Options<GetLivePeerComparisonData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetLivePeerComparisonResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/responses/live_peer_comparison.json", ...options });
	}

	/**
	 * Get current answersheet
	 */
	public static getApiResponsesJson<ThrowOnError extends boolean = true>(
		options?: Options<GetApiResponsesJsonData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetApiResponsesJsonResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/responses.json", ...options });
	}

	/**
	 * create response
	 */
	public static saveAnswer<ThrowOnError extends boolean = true>(
		options?: Options<SaveAnswerData, ThrowOnError>,
	) {
		return (options?.client ?? client).post<
			SaveAnswerResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/responses.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}

export class SubmissionsService {
	/**
	 * Get ABIM info and submissions by year
	 */
	public static getSubmissionsSummary<ThrowOnError extends boolean = true>(
		options?: Options<GetSubmissionsSummaryData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetSubmissionsSummaryResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/submissions.json", ...options });
	}

	/**
	 * Submit credits for a year
	 */
	public static submitCredits<ThrowOnError extends boolean = true>(
		options?: Options<SubmitCreditsData, ThrowOnError>,
	) {
		return (options?.client ?? client).post<
			SubmitCreditsResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/submissions.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}

	/**
	 * Get annual summary for a year
	 */
	public static getSubmissionAnnualSummary<ThrowOnError extends boolean = true>(
		options: Options<GetSubmissionAnnualSummaryData, ThrowOnError>,
	) {
		return (options.client ?? client).get<
			GetSubmissionAnnualSummaryResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/submissions/{id}.json", ...options });
	}

	/**
	 * Get ABIM info
	 */
	public static getAbimInfo<ThrowOnError extends boolean = true>(
		options?: Options<GetAbimInfoData, ThrowOnError>,
	) {
		return (options?.client ?? client).get<
			GetAbimInfoResponses,
			unknown,
			ThrowOnError
		>({ url: "/api/submissions/abim_info.json", ...options });
	}

	/**
	 * Update ABIM info
	 */
	public static updateAbimInfo<ThrowOnError extends boolean = true>(
		options?: Options<UpdateAbimInfoData, ThrowOnError>,
	) {
		return (options?.client ?? client).patch<
			UpdateAbimInfoResponses,
			unknown,
			ThrowOnError
		>({
			url: "/api/submissions/abim_info.json",
			...options,
			headers: {
				"Content-Type": "application/json",
				...options?.headers,
			},
		});
	}
}
